function menu() {
	var btn = document.getElementById("js-mobile-btn");
	var nav = document.getElementById("js-navigation");
	var close = document.getElementById("js-close-btn");

	// btn.addEventListener('click', function () {
	// 	btn.classList.toggle('active');
	// 	btn.classList.toggle('not-active');
	// 	nav.classList.toggle('active');
	// 	document.body.classList.toggle('menu-open');
	// });

	close.addEventListener('click', function () {
		btn.classList.remove('active');
		btn.classList.add('not-active');
		nav.classList.remove('active');
		document.body.classList.remove('menu-open');
	});
}

function navigation() {
	const triggers = document.querySelectorAll('.menu-item-has-children > a');
	const backs = document.querySelectorAll('.sub-menu-back, .sub-menu .submenu-back-icon, .sub-menu-back a');

	const closeAllSubmenus = () => {
		document.querySelectorAll('.menu-item-has-children.submenu-open').forEach(li => li.classList.remove('submenu-open'));
	};

	triggers.forEach(trigger => {
		trigger.addEventListener('click', evt => {
			evt.preventDefault();
			const parentLi = trigger.closest('.menu-item-has-children');
			const isOpen = parentLi.classList.contains('submenu-open');

			closeAllSubmenus();
			if (!isOpen) parentLi.classList.add('submenu-open');
		});
	});

	backs.forEach(btn => {
		btn.addEventListener('click', evt => {
			evt.preventDefault();
			closeAllSubmenus();
		});
	});
}

export {menu, navigation};
